import PropTypes from 'prop-types';
import React from 'react';

import styled from '@emotion/styled';
import classNames from 'classnames';

const Wrapper = styled.div`
  &.MaterialButtonWrapper {
    width: 280px;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    ${(props) => props.mb && `margin-bottom: 2.4rem`};
  }
`;

const MaterialButtonWrapper = (props) => {
  const { className, children, ...rest } = props;

  return (
    <Wrapper {...rest} className={classNames(MaterialButtonWrapper.displayName, className)}>
      {children}
    </Wrapper>
  );
};

MaterialButtonWrapper.displayName = 'MaterialButtonWrapper';

MaterialButtonWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  mb: PropTypes.string,
};

export default MaterialButtonWrapper;
